import { useEffect, useState } from 'react';

const phrases = ['Finding your vibe…', 'Connecting the dots…', 'Thinking it through…'];

export function VibeCheckThinking() {
  const [phrase, setPhrase] = useState(0);
  useEffect(() => {
    const timer = window.setInterval(() => setPhrase(index => (index + 1) % phrases.length), 4500);
    return () => window.clearInterval(timer);
  }, []);
  return <div className="vibe-check-thinking" role="status" aria-label="Vibe Check is thinking">
    <span className="vibe-check-thinking-wave" aria-hidden="true">
      {[0, 1, 2, 3, 4].map(index => <span key={index} style={{ animationDelay: `${index * 120}ms` }} />)}
    </span>
    <span aria-hidden="true">{phrases[phrase]}</span>
    <span className="vibe-check-sr-only">Thinking through your idea.</span>
  </div>;
}
